module.exports = __webpack_public_path__ + "img/green-3-oval-open.6ad337c5.svg";